import { useState, useCallback } from 'react';

export const useAiRequest = () => {
  const [state, setState] = useState({ loading: false, error: '', data: null });

  const run = useCallback(async (fn) => {
    setState({ loading: true, error: '', data: null });
    try {
      const data = await fn();
      setState({ loading: false, error: '', data });
    } catch (err) {
      setState({ loading: false, error: err.message || 'AI is unavailable right now.', data: null });
    }
  }, []);

  const reset = useCallback(() => setState({ loading: false, error: '', data: null }), []);

  return { ...state, run, reset };
};